import { render, staticRenderFns } from "./AnxContact.vue?vue&type=template&id=710bf1b0&scoped=true&"
import script from "./AnxContact.vue?vue&type=script&lang=ts&"
export * from "./AnxContact.vue?vue&type=script&lang=ts&"
import style0 from "./AnxContact.vue?vue&type=style&index=0&id=710bf1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710bf1b0",
  null
  
)

export default component.exports